import React from "react";
import { graphql } from "gatsby";
import * as styles from "./dates.module.css";
import { movieDate } from "../utils/date";

const Date = ({ data }) => {
  return (
    <ol className={styles.articles}>
      {data.map(value => (
        <li className={styles.articles__article}>
          <a className={styles.articles__link}>
            <div
              className={`${styles.articles__content} ${styles["articles__contentLhs"]}`}
            >
              <div className={styles.containerImage}>
                <img
                  className={styles.image}
                  src={value.node.frontmatter.image}
                />
              </div>

              <div className={styles.articles__footer}>
                <p>{value.node.frontmatter.location}</p>
                <p>{movieDate(value.node.frontmatter.date)}</p>
              </div>
            </div>
            <div
              className={`${styles.articles__content} ${styles["articles__contentRhs"]}`}
              aria-hidden="true"
            >
              <div className={styles.containerImage}>
                <img
                  className={styles.image}
                  src={value.node.frontmatter.image}
                />
              </div>

              <div className={styles.articles__footer}>
                <p>{value.node.frontmatter.location}</p>
                <p>{movieDate(value.node.frontmatter.date)}</p>
              </div>
            </div>
          </a>
        </li>
      ))}
    </ol>
  );
};

export default function Dates({ data }) {
  return (
    <div className={styles.outer}>
      <Date data={data.allMarkdownRemark.edges} />
    </div>
  );
}

export const query = graphql`
  query {
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: "//cards//" } }) {
      edges {
        node {
          frontmatter {
            name
            image
            date
            location
            withwhom
            topics {
              heading
              points
            }
          }
        }
      }
    }
  }
`;
